import React from 'react';

/* Inline SVG icons (24x24, stroke style) for the FactLoader — only the ones
   actually referenced by DIRECTORY_FACTS below. */
export const FACT_ICONS: Record<string, React.ReactNode> = {
    spark: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 3v4M12 17v4M3 12h4M17 12h4M5.6 5.6l2.8 2.8M15.6 15.6l2.8 2.8M18.4 5.6l-2.8 2.8M8.4 15.6l-2.8 2.8" />
        </svg>
    ),
    chat: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round">
            <path d="M21 11.5a8.5 8.5 0 0 1-8.5 8.5c-1.5 0-2.9-.38-4.13-1.05L3 20l1.05-5.37A8.5 8.5 0 1 1 21 11.5z" />
        </svg>
    ),
    briefcase: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="7" width="18" height="13" rx="2" />
            <path d="M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2M3 13h18" />
        </svg>
    ),
    refresh: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round">
            <path d="M21 12a9 9 0 1 1-2.64-6.36" />
            <path d="M21 3v6h-6" />
        </svg>
    ),
    users: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round">
            <circle cx="9" cy="8" r="3.5" />
            <path d="M2.5 20c0-3.5 3-5.5 6.5-5.5s6.5 2 6.5 5.5" />
            <circle cx="17" cy="9" r="2.5" />
            <path d="M17 14.5c2.8 0 4.5 1.7 4.5 4" />
        </svg>
    ),
    star: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 3l2.7 5.8 6.3.8-4.6 4.3 1.2 6.1L12 17l-5.6 3 1.2-6.1L3 9.6l6.3-.8L12 3z" />
        </svg>
    ),
    calendar: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="5" width="18" height="16" rx="2" />
            <path d="M8 3v4M16 3v4M3 10h18" />
        </svg>
    ),
    gradcap: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round">
            <path d="M2 9l10-5 10 5-10 5L2 9z" />
            <path d="M6 11.5V16c0 1.5 2.7 3 6 3s6-1.5 6-3v-4.5M22 9v5" />
        </svg>
    ),
    database: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round">
            <ellipse cx="12" cy="5" rx="8" ry="3" />
            <path d="M4 5v6c0 1.66 3.58 3 8 3s8-1.34 8-3V5" />
            <path d="M4 11v6c0 1.66 3.58 3 8 3s8-1.34 8-3v-6" />
        </svg>
    ),
};

export interface Fact {
    icon: keyof typeof FACT_ICONS;
    text: React.ReactNode;
}

/* Final copy — shown as a random subset while alumni/recruiter/domain-expert
   directory searches are in flight. */
export const DIRECTORY_FACTS: Fact[] = [
    { icon: 'spark', text: <>Good things take a few moments. Great alumni networks take a decade. <span className="uv-punch">You get both here!</span></> },
    { icon: 'chat', text: <><span className="uv-punch">"Our alumni data is 100% up to date."</span><br />— Said no one ever.</> },
    { icon: 'refresh', text: <>Somewhere right now, an alumnus/alumna just changed jobs. <span className="uv-punch">Don't worry, we'll find out!</span></> },
    { icon: 'calendar', text: <>Reunions happen once a year. <span className="uv-punch">This platform is the other 364 days.</span></> },
    { icon: 'users', text: <>Great alumni networks aren't built overnight — <span className="uv-punch">they're built one connection at a time.</span></> },
    { icon: 'briefcase', text: <>Opportunities grow when alumni stay connected. <span className="uv-punch">We are making it happen!</span></> },
    { icon: 'gradcap', text: <>A student journey doesn't end at graduation — <span className="uv-punch">it evolves through the alumni network.</span></> },
    { icon: 'star', text: <>Behind every great institution is <span className="uv-punch">an even greater alumni community.</span></> },
    { icon: 'database', text: <>Behind this loading screen: <span className="uv-punch">2 Million+ data points, 20+ Tools and 1 super dedicated Univariety Team!</span></> },
];
